"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLowEndDevice;

function isLowEndDevice() {
  // If number of logical processors available to run threads <= 4
  if (navigator.hardwareConcurrency != null && navigator.hardwareConcurrency <= 4) {
    return true;
  } // If the approximate amount of RAM client device has <= 4GiB


  if (navigator.deviceMemory != null && navigator.deviceMemory <= 4) {
    return true;
  }

  return false;
}